// アプリユーザAPI.
// キーを変えるため通常のMoffAPIとはActionは分割.
import * as InterestCheck from '../constants/InterestCheck';
import { AppUserAPI } from '../api/AppUser';

/**
 * 興味関心チェックの最終登録日を取得.
 * Componentから呼ばれる.
 *
 * @param {string} userId
 * @param {HTMLElement[]} elements
 * @returns
 */
export const getInterestCheckLastDate = (userId: string, elements: HTMLElement[]): any => {
  // API
  const appUser = AppUserAPI.instance;
  if (appUser === null) {
    return {
      type: InterestCheck.FINISH,
      result: '不明なエラーが発生しました.',
    };
  }

  return appUser.getInterestCheckLastDate(
    userId, elements, () => {
      return {
        type: InterestCheck.LOADING,
        result: null,
      };
    },
    (status: any, result: any) => {
      switch (status) {
        case InterestCheck.LOADING:
          return {
            type: InterestCheck.LOADING,
            result: null,
          };
        case InterestCheck.FINISH:
          return {
            type: InterestCheck.FINISH,
            result: {
            }
          };
        default:
          return {
            type: InterestCheck.FINISH,
            result: '不明なエラーが発生しました.',
          };
      }
  });
};


// WEBPACK FOOTER //
// ./src/actions/InterestCheck.tsx